import React from 'react';
import Slider from 'react-slick';
import { jsx, css } from '@emotion/core';

import SlickArrow from '../../../shared/SlickArrow/SlickArrow';
import { primary_l50 } from '../../../shared/lib/colors';

import './BigBanner.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const BigBanner = ({
  home,
  primaryColor,
  uiVariantSlider,
  rounded = false,
  dotsOnRight = false,
  withThumbnails = false,
  ...props
}) => {
  const {
    sliderTopSlide1Image: slide1Image,
    sliderTopSlide1Link: slide1Link,
    sliderTopSlide1SeoName: slide1SeoName,
    sliderTopSlide2Image: slide2Image,
    sliderTopSlide2Link: slide2Link,
    sliderTopSlide2SeoName: slide2SeoName,
    sliderTopSlide3Image: slide3Image,
    sliderTopSlide3Link: slide3Link,
    sliderTopSlide3SeoName: slide3SeoName,
    sliderTopSlide4Image: slide4Image,
    sliderTopSlide4Link: slide4Link,
    sliderTopSlide4SeoName: slide4SeoName,
    sliderTopSlide5Image: slide5Image,
    sliderTopSlide5Link: slide5Link,
    sliderTopSlide5SeoName: slide5SeoName,
    sliderTopSlide6Image: slide6Image,
    sliderTopSlide6Link: slide6Link,
    sliderTopSlide6SeoName: slide6SeoName,
  } = home;

  const dotsStyle = css`
    .slick-dots {
      display: flex !important;
      align-items: center;
      justify-content: ${dotsOnRight ? 'flex-end' : 'center'};
      position: absolute;
      bottom: ${uiVariantSlider === '1' ? '15px' : '25px'};
      right: ${dotsOnRight ? '15px' : 0};

      li {
        display: block;
        margin: 0 5px;
        height: ${uiVariantSlider === '1' ? '8px' : '10px'};
        width: ${uiVariantSlider === '1' ? '8px' : '10px'};

        &.slick-active {
          height: ${uiVariantSlider === '1' ? '12px' : '10px'};
          width: ${uiVariantSlider === '1' ? '12px' : '10px'};

          .dot {
            height: ${uiVariantSlider === '1' ? '12px' : '10px'};
            width: ${uiVariantSlider === '1' ? '12px' : '10px'};
            background-color: ${uiVariantSlider !== '1'
              ? '#fff'
              : primaryColor};
          }
        }

        .dot {
          padding: 0;
          height: ${uiVariantSlider === '1' ? '8px' : '10px'};
          width: ${uiVariantSlider === '1' ? '8px' : '10px'};
          background-color: ${uiVariantSlider !== '1' ? 'transparent' : '#fff'};
          border: ${uiVariantSlider !== '1' ? '1px solid #fff' : 'none'};
          border-radius: ${uiVariantSlider !== '2' ? '50%' : 0};

          &:before {
            content: none;
          }

          &:focus,
          &:hover,
          &.active {
            background-color: ${uiVariantSlider !== '1'
              ? '#fff'
              : primary_l50(primaryColor)};
          }
        }
      }
    }
  `;

  const getThumbnailImage = num => {
    switch (num) {
      case 1:
        return slide1Image;
      case 2:
        return slide2Image;
      case 3:
        return slide3Image;
      case 4:
        return slide4Image;
      case 5:
        return slide5Image;
      case 6:
        return slide6Image;
      default:
        return null;
    }
  };

  const settings = {
    arrows: true,
    prevArrow: (
      <SlickArrow primaryColor={primaryColor} uiVariant={uiVariantSlider} />
    ),
    nextArrow: (
      <SlickArrow primaryColor={primaryColor} uiVariant={uiVariantSlider} />
    ),
    dots: true,
    customPaging: function(i) {
      return !!withThumbnails ? (
        <a style={{ backgroundImage: `url(${getThumbnailImage(i + 1)})` }} />
      ) : (
        <button className="dot">{/* {i + 1} */}</button>
      );
    },
    dotsClass: !!withThumbnails ? 'slick-thumb' : 'slick-dots',
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div
      className={`big-banner ${rounded ? 'rounded' : ''} ${
        withThumbnails ? 'with-thumbnails' : ''
      }`}
    >
      <Slider {...settings} css={dotsStyle}>
        {slide1Image && (
          <div>
            <a href={slide1Link}>
              <ImageDispatcher
                src={slide1Image}
                alt={slide1SeoName}
                className="img-fluid"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        )}
        {slide2Image && (
          <div>
            <a href={slide2Link}>
              <ImageDispatcher
                src={slide2Image}
                alt={slide2SeoName}
                className="img-fluid"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        )}
        {slide3Image && (
          <div>
            <a href={slide3Link}>
              <ImageDispatcher
                src={slide3Image}
                alt={slide3SeoName}
                className="img-fluid"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        )}
        {slide4Image && (
          <div>
            <a href={slide4Link}>
              <ImageDispatcher
                src={slide4Image}
                alt={slide4SeoName}
                className="img-fluid"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        )}
        {slide5Image && (
          <div>
            <a href={slide5Link}>
              <ImageDispatcher
                src={slide5Image}
                alt={slide5SeoName}
                className="img-fluid"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        )}
        {slide6Image && (
          <div>
            <a href={slide6Link}>
              <ImageDispatcher
                src={slide6Image}
                alt={slide6SeoName}
                className="img-fluid"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        )}
      </Slider>
      {withThumbnails && <div />}
    </div>
  );
};

export default BigBanner;
